import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import BaseSemanticLink from '@base/BaseSemanticLink';

export interface IHeaderDropdownItem {
    id: string;
    label: string;
    link?: string;
    callback?: () => void;
    icon?: IconDefinition;
    className?: string;
}

interface IHeaderDropdownItemProps {
    item: IHeaderDropdownItem;
    onSelect: () => void;
    className?: string;
}

const HeaderDropdownItem: React.FC<IHeaderDropdownItemProps> = ({ item, onSelect, className }) => {
    const itemClasses = clsx(
        'block w-full px-4 font-p1 whitespace-nowrap no-underline hover:bg-blueGray-100 hover:text-blueGray-800 text-left',
        className ?? 'py-2 text-blueGray-600',
        item.className,
    );
    const content = (
        <>
            {item.icon && <FontAwesomeIcon icon={item.icon} className="mr-2" />}
            {item.label}
        </>
    );

    if (item.link) {
        return (
            <BaseSemanticLink id={item.id} className={itemClasses} to={item.link}>
                {content}
            </BaseSemanticLink>
        );
    }

    return (
        <button
            id={item.id}
            type="button"
            className={itemClasses}
            onClick={() => {
                item.callback?.();
                onSelect();
            }}
        >
            {content}
        </button>
    );
};

export default HeaderDropdownItem;
